import { render } from "./ItemPhuongTienDaVanHanh.vue?vue&type=template&id=33e9933a&scoped=true"
import script from "./ItemPhuongTienDaVanHanh.vue?vue&type=script&lang=js"
export * from "./ItemPhuongTienDaVanHanh.vue?vue&type=script&lang=js"

import "./ItemPhuongTienDaVanHanh.vue?vue&type=style&index=0&id=33e9933a&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e9933a"]])

export default __exports__